export const DATE_INTERVAL_TYPE = {
  DATE_INTERVAL_TODAY: 'Today',
  DATE_INTERVAL_YESTERDAY: 'Yesterday',
  DATE_INTERVAL_THIS_MONTH: 'This Month',
  DATE_INTERVAL_LAST_MONTH: 'Last Month'
};
